/**
 * VolumePricing custom element
 * Highlights the active price tier based on quantity input value.
 */
if (!customElements.get("volume-pricing")) {
  customElements.define(
    "volume-pricing",
    class VolumePricing extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.items = this.querySelectorAll(".volume-pricing-item");
        if (!this.items.length) return;

        this.qtyInputs = document.querySelectorAll(
          `#Quantity-Selector-${this.sectionId} input[name="quantity"], #Mini-Quantity-Selector-${this.sectionId} input[name="_mini-quantity"]`,
        );

        this.onQtyChange = (event) => this.updateActiveTier(event.target);
        this.qtyInputs.forEach((input) =>
          input.addEventListener("change", this.onQtyChange),
        );

        this.updateActiveTier();
      }

      disconnectedCallback() {
        this.qtyInputs?.forEach((input) =>
          input.removeEventListener("change", this.onQtyChange),
        );
      }

      updateActiveTier(changedInput = null) {
        const qtyInput = changedInput || this.qtyInputs?.[0];
        const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        let activeItem = null;
        this.items.forEach((item) => {
          item.classList.remove("volume-pricing-item--active");
          const minQty = parseInt(item.dataset.minQty, 10);
          if (qty >= minQty) activeItem = item;
        });

        if (activeItem) activeItem.classList.add("volume-pricing-item--active");
      }
    },
  );
}
